/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import tw from 'twin.macro';

import ChevronDown from '@/assets/images/icons/ChevronDown';
import { BodyText, Title } from '@/components';
import { DeviceInfoContext } from '@/contexts/device-info-context';
function RevealingContainer({ cardInfo, withSticker = false }) {
  const [open, setOpen] = useState(false);
  const { isMobile } = useContext(DeviceInfoContext);
  return (
    <div tw='bg-[#444444] p-5 rounded-2xl flex w-full relative' onClick={() => setOpen(!open)}>
      {/* <Title
        text={
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button tw='flex'>
                  {open ? <ChevronDown /> : <ChevronUp />}
                  <span tw=''>{cardInfo.title}</span>
                </Disclosure.Button>
                <Disclosure.Panel tw='ml-12'>
                  <div tw='flex flex-col gap-3 mt-5'>
                    {cardInfo?.info.map(item => (
                      <SubTitle text={item} key={item} />
                    ))}
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        }
        twStyle={tw`text-s14 text-secondary`}
      /> */}

      <AnimatePresence>
        <motion.div
          tw='h-[25px] mr-3'
          onClick={() => setOpen(!open)}
          animate={open ? { rotate: '180deg' } : {}}
          transition={{ duration: 0.3 }}
        >
          <ChevronDown />
        </motion.div>
      </AnimatePresence>
      {withSticker && <span tw='bg-[#2A8640] py-0 px-3 rounded-xl absolute top-6 right-4'>удобно</span>}
      <div tw=''>
        <Title
          text={cardInfo.title}
          twStyle={[
            tw`text-[#70FF6E]`,
            withSticker && tw`sm:max-w-[300px] max-w-[180px]`,
            isMobile && (open ? tw`text-[#70FF6E]` : tw`text-tertiary`)
          ]}
        />
        <BodyText text={cardInfo.caption} twStyle={tw`text-secondary mt-2`} />
        {/* {open && <motion.div tw='flex flex-col gap-5 mt-8 mb-2'></motion.div>} */}
        <AnimatePresence>
          <motion.div
            initial={{ height: '0px', marginTop: 0, marginBottom: 0 }}
            animate={
              open
                ? { height: 'auto', marginTop: '32px', marginBottom: '8px' }
                : { height: '0px', marginTop: 0, marginBottom: 0 }
            }
            exit={{ height: '0px' }}
            transition={{ duration: 0.3 }}
            tw='flex flex-col gap-5 overflow-hidden'
          >
            {cardInfo?.info.map(item => (
              <BodyText text={item} key={item} />
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default RevealingContainer;
